(function () {
  'use strict';
  console.log('[TFH-BID] script loaded v3');

  function getAmount(obj) {
    if (!obj) return null;
    if (typeof obj === 'string') return obj;
    if (obj.display) return obj.display;
    if (obj.amount) return getAmount(obj.amount);
    return null;
  }

  function applyBidPrices() {
    var setup = window.auctionPlusSetup;
    if (!setup || !setup.auctions || !setup.auctions.length) return;

    var byHandle = {};
    setup.auctions.forEach(function (a) {
      var h = a.partner_product_handle || a.product_handle || a.handle;
      if (h) byHandle[h] = a;
    });
    if (!Object.keys(byHandle).length) return;

    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var parts = link.href.split('/products/');
      if (parts.length < 2) return;
      var handle = parts[1].split('?')[0].split('/')[0];
      var auction = byHandle[handle];
      if (!auction) return;

      var hasBid = auction.total_bids && auction.total_bids > 0 && auction.high_bid;
      var amount = hasBid ? getAmount(auction.high_bid) : getAmount(auction.start_price);
      if (!amount) return;
      var label = hasBid ? 'Current Bid' : 'Starting Bid';
      var color = hasBid ? '#7dd3fc' : '#dedede';

      var priceRegular = card.querySelector('.price__regular .price-item--regular');
      if (!priceRegular) return;
      if (priceRegular.querySelector('span[style]')) return;

      priceRegular.innerHTML =
        '<span style="display:flex;flex-direction:column;gap:1px;">' +
          '<span style="color:#9ca3af;font-size:10px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;">' + label + '</span>' +
          '<span style="color:' + color + ';font-size:1em;font-weight:700;">' + amount + '</span>' +
        '</span>';

      var salePriceEl = card.querySelector('.price__sale');
      if (salePriceEl) salePriceEl.style.display = 'none';

      var visLabel = card.querySelector('.price__regular .visually-hidden');
      if (visLabel) visLabel.style.display = 'none';
    });
  }

  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    applyBidPrices();
    if (attempts >= 120) clearInterval(interval);
  }, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBidPrices);
  } else {
    applyBidPrices();
  }
})();